import React from 'react';

const ArrowLeft = () => (
  <svg
    width="10"
    height="9"
    viewBox="0 0 10 9"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M5.0001 0L5.0001 8" stroke="#FF8286" strokeWidth="2" />
    <path
      d="M1.0999 4L4.9999 8L8.8999 4"
      stroke="#FF8286"
      strokeWidth="2"
      strokeLinejoin="round"
    />
  </svg>
);

export default ArrowLeft;
